/** 应用分包表格头配置 */
module.exports = (s) => {
  const system_status_enum = require('./system-status-enum.js')();
  return [
    { name: '所属游戏ID', value: 'game.id', align: 'center', overflow: false },
    { name: '所属游戏名称', value: 'game.name', align: 'center', width: 220, overflow: false },
    { name: '渠道包名称', value: 'name', overflow: false, align: 'center' },
    { name: '渠道包ID', value: 'channel_package_id', align: 'center' },
    { name: '渠道标识', value: 'channel_id', align: 'center' },
    {
      name: '渠道包状态',
      align: 'center',
      value: 'system_status',
      format: (row, cell, cellValue) => {
        return system_status_enum[cellValue];
      },
    },
    { name: '创建时间', value: 'created_time', align: 'center' },
    { name: '最后修改时间', value: 'updated_time', align: 'center' },
    {
      name: '操作',
      value: '',
      props: { fixed: 'right', align: 'center', width: 120 },
      format: (row) => {
        const h = s.$createElement;
        const ele = h('div',
          null, [
            h('el-button',
              {
                props: {
                  size: 'mini',
                },
                on: {
                  click: (event) => {
                    /** 阻止事件冒泡、防止点击影响表格的行点击选中状态 */
                    event.stopPropagation();
                    s.updateExtendPackage(row);
                  },
                },
              },
              '更新渠道包'
            ),
          ]
        );
        return ele;
      },
    },
  ];
};
